import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'Calendar',
      title: 'Agenda Inteligente',
      description: 'Gerencie seus horários com facilidade. Visualize disponibilidade, confirme consultas e evite conflitos. Aumente seu faturamento em 20%.',
      color: 'var(--color-primary)',
    },
    {
      icon: 'MessageCircle',
      title: 'WhatsApp Automático',
      description: 'Envie confirmações, lembretes e notificações automaticamente via WhatsApp. Reduza faltas em até 70%.',
      color: 'var(--color-success)',
    },
    {
      icon: 'Users',
      title: 'Gestão de Pacientes',
      description: 'Mantenha registros completos de pacientes, histórico de consultas e informações de contato em um só lugar.',
      color: 'var(--color-accent)',
    },
    {
      icon: 'BarChart3',
      title: 'Relatórios Detalhados',
      description: 'Acompanhe receitas, taxa de ocupação e métricas importantes para o crescimento da sua prática.',
      color: 'var(--color-warning)',
    },
    {
      icon: 'Globe',
      title: 'Agendamento Público',
      description: 'Página personalizada para seus pacientes agendarem consultas online 24/7 com sua marca.',
      color: 'var(--color-primary)',
    },
    {
      icon: 'Bell',
      title: 'Notificações Inteligentes',
      description: 'Alertas sonoros configuráveis e notificações em tempo real para nunca perder um compromisso.',
      color: 'var(--color-error)',
    },
  ];

  return (
    <section id="features" className="py-20 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Zap" size={16} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">
              Recursos Poderosos
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Tudo que você precisa em um só lugar
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Ferramentas profissionais desenvolvidas especificamente para psicólogos e terapeutas modernos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="group bg-card rounded-2xl p-8 border border-border hover:shadow-elevated transition-all duration-300 hover:-translate-y-1"
            >
              <div
                className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110"
                style={{ backgroundColor: `${feature?.color}15` }}
              >
                <Icon name={feature?.icon} size={28} color={feature?.color} />
              </div>
              <h3 className="text-xl font-semibold text-foreground mb-3">
                {feature?.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;